@if (metrics.length > 0) {
  <div class="tracking-page-metrics-container">
    <div class="grid-container">
      @for (metric of metrics; track metric) {
        <metric
          [value]="metric.value"
          [suffix]="metric.suffix"
          [prefix]="metric.prefix"
          [loading]="isTrackingPageLoading"
          [title]="metric.title"></metric>
      }
    </div>
  </div>
}
